module.exports = __webpack_public_path__ + "static/media/Endoplasmatic v7.7f5eeb57.glb";